import {LoadingOverlay as LoadingOverlayUI} from '@travel-frontend/ui-components';
import {memo} from 'react';
import {useTranslation} from 'react-i18next';

type LoadingOverlayProps = {
  visible: boolean;
};

export const LoadingOverlay = memo(function LoadingOverlay({
  visible,
}: LoadingOverlayProps) {
  const {t} = useTranslation('hotels');

  return (
    <LoadingOverlayUI
      visible={visible}
      title={t('mapView.loadingOverlay.title')}
      subtitle={t('mapView.loadingOverlay.subtitle')}
    />
  );
});
